import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api` });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("gi_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !err.config.url.includes("/auth/login")) {
      localStorage.removeItem("gi_token");
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Er ging iets mis";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export const orthoUrl = (aid, year) => `${BACKEND}/api/ortho/${aid}/${year}`;
export const heatUrl = (anid) => `${BACKEND}/api/analyses/${anid}/heatmap.png`;
const tok = () => localStorage.getItem("gi_token");
export const rawUrl = (uid) => `${BACKEND}/api/uploads/${uid}/raw?auth=${tok()}`;
export const alignedUrl = (uid, v = "") => `${BACKEND}/api/uploads/${uid}/aligned.jpg?auth=${tok()}&v=${v}`;
export const compareSrc = (aid, an) => (an.upload_id ? `${BACKEND}/api/analyses/${an.id}/compare.jpg?auth=${tok()}` : orthoUrl(aid, an.compare_year));
export const compareLabel = (an) => (an.upload_id ? an.compare_label : `NIEUW ${an.compare_year}`);

export const STATUS = {
  nieuw: { label: "Nieuw", cls: "bg-amber-500/10 text-amber-400 border-amber-500/30" },
  inspecteren: { label: "Inspecteren", cls: "bg-sky-500/10 text-sky-400 border-sky-500/30" },
  bezoeken: { label: "Bezoeken", cls: "bg-orange-500/10 text-orange-400 border-orange-500/30" },
  doorgezet: { label: "Doorgezet (handhaving)", cls: "bg-rose-500/10 text-rose-400 border-rose-500/30" },
  vergund: { label: "Vergund", cls: "bg-lime-500/10 text-lime-400 border-lime-500/30" },
  goedgekeurd: { label: "Goedgekeurd", cls: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30" },
  afgewezen: { label: "Afgewezen", cls: "bg-slate-500/10 text-slate-400 border-slate-500/30" },
  afgehandeld: { label: "Afgehandeld", cls: "bg-teal-500/10 text-teal-300 border-teal-500/30" },
  geen_wijziging: { label: "Geen wijziging", cls: "bg-slate-500/10 text-slate-400 border-slate-600/30" },
  niet_geanalyseerd: { label: "Niet geanalyseerd", cls: "bg-slate-800 text-slate-500 border-slate-700" },
};
export async function downloadFile(path, filename) {
  const { data } = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export const OPEN_STATUSES = ["nieuw", "inspecteren", "bezoeken", "doorgezet"];
